import { useCallback, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

export const useEditAlertMode = () => {
  const history = useHistory();
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const previousAlertId = params.get('edit_alert');
  const isEditingSearchAlert = !!previousAlertId;

  const quitEditMode = useCallback(() => {
    params.delete('edit_alert');
    history.replace({ search: params.toString() });
  }, [history, params]);

  // We remove the `edit_alert` param in case the user presses the back button
  useEffect(() => {
    return history.listen((location) => {
      if (history.action === 'POP') {
        const params = new URLSearchParams(location.search);
        const previousAlertId = params.get('edit_alert');

        if (previousAlertId) {
          params.delete('edit_alert');
          history.replace({ search: params.toString() });
        }
      }
    });
  }, [history]);

  return { isEditingSearchAlert, previousAlertId, quitEditMode };
};
